<template>
  <div>
    <v-btn style="z-index: 100000" absolute top large right icon color="red" @click="openCancelConfirm()">       <v-icon>mdi-close</v-icon> </v-btn>
    <div v-if="!isMobile">
      <v-row no-gutters>
        <v-col cols="auto">
          <v-avatar size="80">             <v-img cover :src="getImageForExercise(exercise)" position="top center"></v-img> </v-avatar>
        </v-col>
        <v-col class="align-center">
                    <v-card-title class="pb-0">{{ exercise.title }}</v-card-title>
        </v-col>
      </v-row>
      <v-alert
        v-if="activeTechniqueInfo && activeTechniqueInfo.details"
        style="background: rgba(255, 255, 255, 0.05)"
        :color="activeTechniqueInfo.color"
        border="left"
        elevation="2"
        colored-border
        class="mt-4 mb-4 intensity-alert"
        dark>
        <div class="d-flex align-center">
                    <v-icon :color="activeTechniqueInfo.color" class="mr-3">{{ activeTechniqueInfo.icon }}</v-icon>
          <div class="font-weight-bold">{{ activeTechniqueInfo.descriptionShort }}</div>
          <v-btn icon small class="ml-auto" @click="toggleIntensityAlertExpansion">
                        <v-icon>{{ isIntensityAlertExpanded ? "mdi-chevron-up" : "mdi-information-outline" }}</v-icon>
          </v-btn>
        </div>
        <v-expand-transition>
          <div v-show="isIntensityAlertExpanded" class="intensity-details-expanded mt-2">
                        <v-divider></v-divider>
            <div class="px-1">
              <p class="subtitle-1 font-weight-bold font-italic">"{{ activeTechniqueInfo.details.summary }}"</p>
              <p class="body-2 mb-4">{{ activeTechniqueInfo.description }}</p>
              <v-row>
                <v-col cols="12" md="6" v-if="activeTechniqueInfo.details.advantages && activeTechniqueInfo.details.advantages.length">
                  <h4 class="mt-4 mb-2 text-uppercase text-caption" :style="{ color: getSectionHeadlineColor(activeTechniqueInfo.color) }"></h4>
                  <v-list dense color="transparent" class="pa-0">
                    <v-list-item v-for="(advantage, index) in activeTechniqueInfo.details.advantages" :key="'adv-' + index" class="px-0 py-1">
                                           
                      <v-list-item-icon class="mr-3 my-0">
                                                <v-icon small :color="getIconColorForItem('advantage')">{{ advantage.icon }}</v-icon>

                                             
                      </v-list-item-icon>

                                           
                      <v-list-item-content class="py-0">
                                                <v-list-item-title class="body-2 white--text">{{ advantage.text }}</v-list-item-title>

                                             
                      </v-list-item-content>

                                         
                    </v-list-item>

                                     
                  </v-list>

                                 
                </v-col>

                               
                <v-col cols="12" md="6" v-if="activeTechniqueInfo.details.whyDoIt && activeTechniqueInfo.details.whyDoIt.length">
                                   
                  <h4 class="mt-4 mb-2 text-uppercase text-caption" :style="{ color: getSectionHeadlineColor(activeTechniqueInfo.color, true) }">
                                        Warum diese Technik?                  
                  </h4>

                                   
                  <v-list dense color="transparent" class="pa-0">
                                       
                    <v-list-item v-for="(reason, index) in activeTechniqueInfo.details.whyDoIt" :key="'reason-' + index" class="px-0 py-1">
                                           
                      <v-list-item-icon class="mr-3 my-0">
                                                <v-icon small :color="getIconColorForItem('reason')">{{ reason.icon }}</v-icon>

                                             
                      </v-list-item-icon>

                                           
                      <v-list-item-content class="py-0">
                                                <v-list-item-title class="body-2 white--text">{{ reason.text }}</v-list-item-title>

                                             
                      </v-list-item-content>

                                         
                    </v-list-item>

                                     
                  </v-list>

                                 
                </v-col>

                             
              </v-row>

                         
            </div>

                     
          </div>

                 
        </v-expand-transition>

             
      </v-alert>

           
      <v-row no-gutters>
               
        <v-col cols="12">
                    <v-divider color="white"></v-divider>

                 
        </v-col>

               
        <v-col cols="12" v-if="exercise.general_exercise_settings && exercise.general_exercise_settings.length">
                   
          <v-row no-gutters>
                       
            <v-col cols="auto">
                            <v-card-title class="px-1 py-1 font-weight-bold">Geräteeinstellungen</v-card-title>

                         
            </v-col>

                       
            <v-col class="align-content-center" v-if="savedGeneralExerciseSettings" cols="grow">
                           
              <v-btn class="ma-1" x-small fab color="blue" @click="savedGeneralExerciseSettings = false">
                                <v-icon>mdi-pencil</v-icon>

                             
              </v-btn>

                           
              <v-chip
                color="grey"
                class="mr-2"
                v-for="(setting, index) in exercise.general_exercise_settings.filter((setting) => setting.value)"
                :key="'setting' + index">
                                <span>{{ shorten(setting.text) + " | " + setting.value }}</span>

                             
              </v-chip>

                         
            </v-col>

                     
          </v-row>

                   
          <v-expand-transition mode="out-in" v-if="!savedGeneralExerciseSettings">
                       
            <v-row no-gutters>
                           
              <v-col
                cols="auto"
                class="pa-1 d-flex align-center"
                :key="index + 'deviceSetting'"
                v-for="(deviceSetting, index) in exercise.general_exercise_settings">
                <v-card
                  class="input-card"
                  :style="deviceSetting && deviceSetting.input === 'selection' ? 'width: 150px !important' : 'width: 150px !important'"
                  flat
                  color="rgba(255,255,255,0.08)">
                                   
                  <div class="text-caption grey--text text--lighten-1 px-2 pt-1">                    {{ shorten(deviceSetting.text, 10) }}</div>
                                                       
                  <v-select
                    dense
                    solo
                    flat
                    style="line-height: 1"
                    hide-details
                    class="centered-input"
                    v-model="deviceSetting.value"
                    :items="deviceSetting.selections"
                    v-if="deviceSetting && deviceSetting.input === 'selection'"
                    @keydown.enter.prevent="saveGeneralExerciseSettings()"></v-select>

                                     
                  <v-text-field
                    v-else
                    dense
                    solo
                    flat
                    hide-details
                    class="centered-input"
                    @input="updatingSetting($event, deviceSetting)"
                    :type="deviceSetting.input"
                    v-model="deviceSetting.value"></v-text-field>

                                                   
                </v-card>

                             
              </v-col>

                           
              <v-col cols="auto" class="ml-2 align-content-center">
                               
                <v-btn x-small fab color="primary" @click="saveGeneralExerciseSettings()">
                                    <v-icon>mdi-check</v-icon>

                                 
                </v-btn>

                             
              </v-col>

                         
            </v-row>

                     
          </v-expand-transition>

                    <v-divider color="white"></v-divider>

                 
        </v-col>

        <template v-if="!isSensoProExercise">
          <v-col cols="12" class="mt-4">
            <div class="sets-display-desktop">
              <div class="sets-list-wrapper">
                <p class="text-h6 font-weight-bold">Sätze</p>
                <div v-if="combinedExerciseSets.length > 0" class="sets-list">
                  <div v-for="(set, index) in combinedExerciseSets" :key="index" class="set-item" @click="editSet(index)">
                    <v-icon class="set-icon" :color="exercise.warmup && index === 0 ? 'orange' : 'primary'">
                      {{ exercise.warmup && index === 0 ? "mdi-fire" : "mdi-weight-lifter" }}
                    </v-icon>
                    <div class="set-details">
                      <span class="font-weight-bold">{{
                        exercise.warmup && index === 0 ? "Aufwärmsatz" : "Satz " + (exercise.warmup ? index : index + 1)
                      }}</span>
                      <span class="grey--text text--lighten-1">{{ formatSetForChip(set) }}</span>
                    </div>
                    <v-icon class="edit-icon">mdi-pencil-outline</v-icon>
                  </div>
                </div>
                <p v-else class="grey--text mt-4">Noch keine Sätze hinzugefügt.</p>
              </div>

              <div class="input-form-wrapper glass-card pa-4 mr-2">
                <p class="text-h6 font-weight-bold mb-4">{{ editingSetIndex !== null ? "Satz bearbeiten" : "Satz hinzufügen" }}</p>
                <template v-if="!exercise.sets || !exercise.sets.length">
                  <v-item-group v-model="selectedTechniqueMode" mandatory class="technique-group mb-4">
                    <v-item v-for="mode in availableTechniqueModes" :key="mode.value" :value="mode.value" v-slot="{ active, toggle }">
                      <div @click="toggle" class="technique-item" :class="{ active: active }">
                        <v-icon class="icon">{{ mode.icon }}</v-icon>
                        <span class="label">{{ mode.text }}</span>
                      </div>
                    </v-item>
                  </v-item-group>
                </template>
                <template v-if="selectedTechniqueMode === 'normal' || selectedTechniqueMode === 'warmup'">
                             
                  <v-col cols="12" class="px-0">
                                               
                    <v-row no-gutters>
                                     
                      <v-col
                        cols="auto"
                        class="pa-1 d-flex align-center fill-height"
                        :key="index + 'setSetting'"
                        v-for="(setSetting, index) in orderedSetSettings">
                                         
                        <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                             
                          <div class="text-caption grey--text text--lighten-1 px-2 pt-1">{{ shorten(setSetting.text, 10) }}</div>

                                             
                          <v-select
                            dense
                            solo
                            height="20px"
                            style="line-height: 1"
                            hide-details
                            class="pa-0 ma-0"
                            v-model="setSetting.value"
                            :items="setSetting.selections"
                            v-if="setSetting && setSetting.input === 'selection'"
                            @keydown.enter.prevent="saveSet()">
                                               
                          </v-select>

                                             
                          <v-text-field
                            v-else
                            v-model="setSetting.value"
                            :placeholder="setSetting.text === 'Notiz' ? 'Optional' : '0'"
                            :type="setSetting.text === 'Pause' ? 'number' : setSetting.input"
                            class="centered-input"
                            solo
                            dense
                            flat
                            :suffix="setSetting.text === 'Pause' ? 'sek' : setSetting.text === 'Gewicht' ? 'kg' : ''"
                            hide-details
                            @keydown.enter.prevent="saveSet()"></v-text-field>

                                           
                        </v-card>

                                       
                      </v-col>

                                                   
                    </v-row>

                               
                  </v-col>

                                   
                  <v-col cols="10" class="justify-content-center text-center mt-3">
                                <v-btn color="primary" @click="saveSet()"> {{ editingSetIndex === null ? "hinzufügen" : "speichern" }} </v-btn>
                    <v-btn v-if="editingSetIndex !== null" class="ml-2" color="grey" @click="cancelEditSet"> Abbrechen </v-btn>
                    <v-btn v-if="editingSetIndex !== null" class="ml-2" color="red" @click="removeSetByIndex(editingSetIndex)">Löschen </v-btn>

                             
                  </v-col>
                     
                </template>
                <template v-if="selectedTechniqueMode !== 'normal' && selectedTechniqueMode !== 'warmup'">
                               
                  <v-col class="mt-2 px-0" cols="12">
                                   
                    <v-row no-gutters>
                                       
                      <template v-if="selectedTechniqueMode === 'dropset'">
                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Max-Gewicht</div>

                                                   
                            <v-text-field
                              min="0"
                              v-model="techniqueDropset.maxWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Sätze</div>

                                                   
                            <v-text-field
                              v-model="techniqueDropset.setCount"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Min-WDH</div>

                                                   
                            <v-text-field
                              v-model="techniqueDropset.minReps"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Max-WDH</div>

                                                   
                            <v-text-field
                              v-model="techniqueDropset.maxReps"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Reduktion</div>

                                                   
                            <v-text-field
                              v-model="techniqueDropset.reductionWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                         
                      </template>

                                       
                      <template v-if="selectedTechniqueMode === 'reversedropset'">
                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Max-Gewicht</div>

                                                   
                            <v-text-field
                              v-model="techniqueReverseDropset.maxWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Sätze</div>

                                                   
                            <v-text-field
                              v-model="techniqueReverseDropset.setCount"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Min-WDH</div>

                                                   
                            <v-text-field
                              v-model="techniqueReverseDropset.minReps"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Max-WDH</div>

                                                   
                            <v-text-field
                              v-model="techniqueReverseDropset.maxReps"
                              type="number"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Erhöhung</div>

                                                   
                            <v-text-field
                              v-model="techniqueReverseDropset.expandWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                         
                      </template>

                                       
                      <template v-if="selectedTechniqueMode === 'schockwelle'">
                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Startgewicht</div>

                                                   
                            <v-text-field
                              v-model="techniqueSchockwelle.startWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Zuwachs</div>

                                                   
                            <v-text-field
                              v-model="techniqueSchockwelle.incrementWeight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Pause</div>

                                                   
                            <v-text-field
                              v-model="techniqueSchockwelle.pause"
                              type="number"
                              suffix="sek"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                         
                      </template>

                                       
                      <template v-if="selectedTechniqueMode === 'fst7'">
                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Gewicht</div>

                                                   
                            <v-text-field
                              v-model="techniqueFst7.weight"
                              type="number"
                              suffix="kg"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                           
                        <v-col cols="auto" class="pa-1">
                                               
                          <v-card class="input-card" flat color="rgba(255,255,255,0.08)">
                                                   
                            <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Pause</div>

                                                   
                            <v-text-field
                              v-model="techniqueFst7.pause"
                              type="number"
                              suffix="sek"
                              dense
                              solo
                              flat
                              hide-details
                              class="centered-input"></v-text-field>

                                                 
                          </v-card>

                                             
                        </v-col>

                                         
                      </template>

                                     
                    </v-row>

                                 
                  </v-col>

                         
                  <v-col
                    cols="10"
                    class="justify-content-center text-center mt-3"
                    v-if="selectedTechniqueMode !== 'normal' && selectedTechniqueMode !== 'warmup' && (!exercise.sets || !exercise.sets.length)">
                                <v-btn color="primary" @click="generateSetsForTechnique"> Sätze generieren </v-btn>

                             
                  </v-col>
                     
                </template>
              </div>
            </div>
          </v-col>
        </template>

               
        <v-col cols="12" v-if="!isButtonDisabled" class="mt-4">
                   
          <v-card-actions class="justify-content-center">
                       
            <v-tooltip bottom>
                           
              <template v-slot:activator="{ on }">
                               
                <div v-on="on" style="display: inline-block">
                                   
                  <v-btn class="rounded-xl" :disabled="isButtonDisabled" color="primary" @click="onButtonClick">Änderungen speichern</v-btn>

                                 
                </div>

                             
              </template>

                            <span>{{ tooltipMessage }}</span>

                         
            </v-tooltip>

                     
          </v-card-actions>

                 
        </v-col>

             
      </v-row>

         
    </div>

       
    <div v-else>
           
      <v-row no-gutters class="mb-2">
               
        <v-col cols="auto" class="mr-3">
                   
          <v-avatar size="60" tile class="rounded-lg">
                        <v-img :src="getImageForExercise(exercise)" position="top center"></v-img>

                     
          </v-avatar>

                 
        </v-col>

               
        <v-col class="d-flex flex-column justify-center">
                   
          <h3 class="font-weight-bold line-height-tight">{{ exercise.title }}</h3>

                   
          <p class="caption grey--text text--lighten-1 mb-0">Konfiguriere deine Sätze</p>

                 
        </v-col>

             
      </v-row>

           
      <v-stepper v-model="mobileStepper" vertical dark flat color="transparent" class="pa-0">
               
        <v-stepper-step class="pl-0" :complete="mobileStepper > 1" step="1" editable v-if="exercise.general_exercise_settings.length > 0">
                    Geräteeinstellungen           <small>Optional, für schnelles Setup im Training</small>

                 
        </v-stepper-step>

               
        <v-stepper-content class="pl-0 ml-1 mr-1 pr-1" step="1" v-if="exercise.general_exercise_settings.length > 0">
                   
          <v-row no-gutters>
                       
            <v-col cols="6" md="4" v-for="(setting, i) in exercise.general_exercise_settings" :key="i" class="pa-1">
                           
              <v-card class="rounded-lg" flat color="rgba(255,255,255,0.08)">
                               
                <div class="text-caption grey--text text--lighten-1 px-2 pt-1">{{ setting.text }}</div>

                               
                <v-text-field
                  v-model="setting.value"
                  :type="setting.input === 'number' ? 'number' : 'text'"
                  dense
                  solo
                  flat
                  hide-details
                  class="centered-input" />

                             
              </v-card>

                         
            </v-col>

                     
          </v-row>

                    <v-btn class="mt-4" color="primary" @click="mobileStepper = 2">Weiter</v-btn>

                 
        </v-stepper-content>

               
        <v-stepper-step class="pl-0" :complete="mobileStepper > 2" step="2" editable>
                    Aufwärmsatz           <small>Optional, vor den Arbeitssätzen</small>

                 
        </v-stepper-step>

               
        <v-stepper-content class="pl-0 ml-1 mr-1 pr-1" step="2">
                    <v-switch v-model="hasWarmup" :label="hasWarmup ? 'Aufwärmsatz aktiv' : 'Kein Aufwärmsatz'" color="orange"></v-switch>

                   
          <v-expand-transition>
                       
            <div v-if="hasWarmup">
                           
              <p class="caption">Lege die Werte für deinen einmaligen Aufwärmsatz fest.</p>

                           
              <v-row no-gutters dense>
                               
                <v-col cols="6" md="4" v-for="(setting, i) in exercise.warmup" :key="i" class="pa-1">
                                   
                  <v-card class="rounded-lg" flat color="rgba(255,255,255,0.08)">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">{{ setting.text }}</div>

                                       
                    <v-text-field
                      v-model="setting.value"
                      :type="setting.input === 'number' ? 'number' : 'text'"
                      :suffix="setting.text === 'Pause' ? 'sek' : setting.text === 'Gewicht' ? 'kg' : ''"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input" />

                                     
                  </v-card>

                                 
                </v-col>

                             
              </v-row>

                         
            </div>

                     
          </v-expand-transition>

                    <v-btn class="mt-4" color="primary" @click="mobileStepper = 3">Weiter</v-btn>

                    <v-btn text @click="mobileStepper = 3" class="mt-4">Zurück</v-btn>

                 
        </v-stepper-content>

               
        <v-stepper-step class="pl-0" :complete="mobileStepper > 3" step="3" editable>
                    Trainingsart wählen           <small>Normales Training oder spezielle Technik?</small>

                 
        </v-stepper-step>

               
        <v-stepper-content class="pl-0 ml-1 mr-1 pr-1" step="3">
                   
          <p class="caption">Wähle eine Intensitätstechnik für mehr Abwechslung. Ansonsten ist "Normale Sätze" die Standardwahl.</p>

                   
          <v-item-group v-model="selectedTechniqueMode" mandatory>
                       
            <v-item class="rounded-lg" v-for="mode in mobileTechniqueModes" :key="mode.value" :value="mode.value" v-slot="{ active, toggle }">
                           
              <v-card @click="toggle" rounded-lg :class="{ 'mb-1 intensity-card': true }" dark elevation="2">
                               
                <div class="left-border" :style="{ backgroundColor: intensityTechniqueMapping[mode.value].color }"></div>

                               
                <div :class="{ primary: active }" class="d-flex align-center pa-3 rounded-lg">
                                    <v-icon class="mr-3">{{ intensityTechniqueMapping[mode.value].icon }}</v-icon>

                                   
                  <div class="font-weight-bold">{{ intensityTechniqueMapping[mode.value].descriptionShort }}</div>

                                   
                  <v-btn icon small class="ml-auto" @click.stop="toggleIntensityAlertExpansionMobile(mode.value)">
                                       
                    <v-icon>{{ isIntensityAlertExpandedMobile === mode.value ? "mdi-chevron-up" : "mdi-information-outline" }}</v-icon>

                                     
                  </v-btn>

                                 
                </div>

                               
                <v-expand-transition>
                                   
                  <div v-show="isIntensityAlertExpandedMobile === mode.value" class="intensity-details-expanded mt-2">
                                        <v-divider class="my-3"></v-divider>

                                       
                    <div class="px-1">
                                           
                      <p class="subtitle-1 font-weight-bold font-italic">"{{ intensityTechniqueMapping[mode.value].details.summary }}"</p>

                                           
                      <p class="body-2 mb-4">{{ intensityTechniqueMapping[mode.value].description }}</p>

                                           
                      <div
                        v-if="
                          intensityTechniqueMapping[mode.value].details.advantages && intensityTechniqueMapping[mode.value].details.advantages.length
                        ">
                                               
                        <h4
                          class="mt-4 mb-2 text-uppercase text-caption"
                          :style="{ color: getSectionHeadlineColor(intensityTechniqueMapping[mode.value].color) }">
                                                    Vorteile                        
                        </h4>

                                               
                        <v-list dense color="transparent" class="pa-0">
                                                   
                          <v-list-item
                            v-for="(advantage, index) in intensityTechniqueMapping[mode.value].details.advantages"
                            :key="'adv-mob-' + index"
                            class="px-0 py-1">
                                                       
                            <v-list-item-icon class="mr-3 my-0">
                                                            <v-icon small :color="getIconColorForItem('advantage')">{{ advantage.icon }}</v-icon>

                                                         
                            </v-list-item-icon>

                                                       
                            <v-list-item-content class="py-0">
                                                            <v-list-item-title class="body-2 white--text">{{ advantage.text }}</v-list-item-title>

                                                         
                            </v-list-item-content>

                                                     
                          </v-list-item>

                                                 
                        </v-list>

                                             
                      </div>

                                           
                      <div
                        v-if="intensityTechniqueMapping[mode.value].details.whyDoIt && intensityTechniqueMapping[mode.value].details.whyDoIt.length">
                                               
                        <h4
                          class="mt-4 mb-2 text-uppercase text-caption"
                          :style="{ color: getSectionHeadlineColor(intensityTechniqueMapping[mode.value].color, true) }">
                                                    Warum diese Technik?                        
                        </h4>

                                               
                        <v-list dense color="transparent" class="pa-0">
                                                   
                          <v-list-item
                            v-for="(reason, index) in intensityTechniqueMapping[mode.value].details.whyDoIt"
                            :key="'reason-mob-' + index"
                            class="px-0 py-1">
                                                       
                            <v-list-item-icon class="mr-3 my-0">
                                                            <v-icon small :color="getIconColorForItem('reason')">{{ reason.icon }}</v-icon>

                                                         
                            </v-list-item-icon>

                                                       
                            <v-list-item-content class="py-0">
                                                            <v-list-item-title class="body-2 white--text">{{ reason.text }}</v-list-item-title>

                                                         
                            </v-list-item-content>

                                                     
                          </v-list-item>

                                                 
                        </v-list>

                                             
                      </div>

                                         
                    </div>

                                     
                  </div>

                                 
                </v-expand-transition>

                             
              </v-card>

                         
            </v-item>

                     
          </v-item-group>

                    <v-btn class="ma-auto" color="primary" @click="mobileStepper = 4">Weiter</v-btn>

                 
        </v-stepper-content>

               
        <v-stepper-step class="pl-0" :complete="mobileStepper > 4" step="4" editable>
                    Sätze & Wiederholungen           <small>Definiere dein Training</small>

                 
        </v-stepper-step>

               
        <v-stepper-content class="pl-0 ml-1 mr-1 pr-1" step="4">
                   
          <div v-if="combinedExerciseSets.length > 0" class="mb-4">
                       
            <v-chip
              v-for="(set, index) in combinedExerciseSets"
              :key="index"
              class="ma-1"
              close
              @click:close="removeSetByIndex(exercise.warmup && index === 0 ? -1 : index - (exercise.warmup ? 1 : 0))">
                            <v-icon left small v-if="exercise.warmup && index === 0">mdi-fire</v-icon>

                            Satz {{ exercise.warmup ? index : index + 1 }}:              
              <span class="font-weight-bold ml-1">{{ formatSetForChip(set) }}</span>

                         
            </v-chip>

                     
          </div>

                   
          <div v-if="selectedTechniqueMode === 'normal'">
                       
            <p class="caption">Lege die Standardwerte für deine Sätze fest.</p>

                       
            <v-row no-gutters dense>
                           
              <v-col cols="6" md="4" v-for="(setting, i) in orderedSetSettings" :key="i" class="pa-1">
                               
                <v-card class="rounded-lg" flat color="rgba(255,255,255,0.08)">
                                   
                  <div class="text-caption grey--text text--lighten-1 px-2 pt-1">{{ setting.text }}</div>

                                   
                  <v-text-field
                    v-model="setting.value"
                    :type="setting.input === 'number' ? 'number' : 'text'"
                    :suffix="setting.text === 'Pause' ? 'sek' : setting.text === 'Gewicht' ? 'kg' : ''"
                    dense
                    solo
                    flat
                    hide-details
                    class="centered-input"></v-text-field>

                                 
                </v-card>

                             
              </v-col>

                         
            </v-row>

                        <v-btn depressed color="primary" @click="saveSet" class="mt-4"><v-icon left>mdi-plus</v-icon>Satz hinzufügen</v-btn>

                     
          </div>

                   
          <div v-else>
                       
            <v-row no-gutters v-if="selectedTechniqueMode === 'dropset'">
                           
              <v-col cols="auto" class="mr-3">
                               
                <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                   
                  <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Maximales Gewicht</div>

                                   
                  <v-text-field
                    v-model="techniqueDropset.maxWeight"
                    type="number"
                    suffix="kg"
                    dense
                    solo
                    flat
                    hide-details
                    class="centered-input"></v-text-field>

                                 
                </v-card>

                             
              </v-col>

                           
              <v-col cols="auto" class="mr-3">
                               
                <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                   
                  <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Anzahl Sätze</div>

                                   
                  <v-text-field v-model="techniqueDropset.setCount" type="number" dense solo flat hide-details class="centered-input"></v-text-field>

                                 
                </v-card>

                             
              </v-col>

                           
              <v-col cols="auto" class="mr-3">
                               
                <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                   
                  <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Gewichtsreduktion</div>

                                   
                  <v-text-field
                    v-model="techniqueDropset.reductionWeight"
                    type="number"
                    suffix="kg"
                    dense
                    solo
                    flat
                    hide-details
                    class="centered-input"></v-text-field>

                                 
                </v-card>

                             
              </v-col>

                         
            </v-row>

                       
            <div v-if="selectedTechniqueMode === 'reversedropset'">
                           
              <v-row no-gutters>
                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Maximales Gewicht</div>

                                       
                    <v-text-field
                      v-model="techniqueReverseDropset.maxWeight"
                      type="number"
                      suffix="kg"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Anzahl Sätze</div>

                                       
                    <v-text-field
                      v-model="techniqueReverseDropset.setCount"
                      type="number"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Gewichtserhöhung</div>

                                       
                    <v-text-field
                      v-model="techniqueReverseDropset.expandWeight"
                      type="number"
                      suffix="kg"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                             
              </v-row>

                         
            </div>

                       
            <div v-if="selectedTechniqueMode === 'schockwelle'">
                           
              <v-row no-gutters>
                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Startgewicht</div>

                                       
                    <v-text-field
                      v-model="techniqueSchockwelle.startWeight"
                      type="number"
                      suffix="kg"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card> </v-col
                ><v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Zuwachs</div>

                                       
                    <v-text-field
                      v-model="techniqueSchockwelle.incrementWeight"
                      type="number"
                      suffix="kg"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Pause</div>

                                       
                    <v-text-field
                      v-model="techniqueSchockwelle.pause"
                      type="number"
                      suffix="sek"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                             
              </v-row>

                         
            </div>

                       
            <div v-if="selectedTechniqueMode === 'fst7'">
                           
              <v-row no-gutters>
                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Gewicht</div>

                                       
                    <v-text-field
                      v-model="techniqueFst7.weight"
                      type="number"
                      suffix="kg"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                               
                <v-col cols="auto" class="mr-3">
                                   
                  <v-card flat color="rgba(255,255,255,0.08)" class="mb-2 rounded-lg" style="max-width: 150px">
                                       
                    <div class="text-caption grey--text text--lighten-1 px-2 pt-1">Pause</div>

                                       
                    <v-text-field
                      v-model="techniqueFst7.pause"
                      type="number"
                      suffix="sek"
                      dense
                      solo
                      flat
                      hide-details
                      class="centered-input"></v-text-field>

                                     
                  </v-card>

                                 
                </v-col>

                             
              </v-row>

                         
            </div>

                       
            <v-btn color="secondary" depressed @click="generateSetsForTechnique" class="mt-4"
              ><v-icon left>mdi-auto-fix</v-icon>Sätze generieren</v-btn
            >

                     
          </div>

                   
          <div class="mt-6">
                       
            <v-btn
              text
              @click="
                () => {
                  mobileStepper = 3

                  exercise.sets = []
                }
              "
              >Zurück</v-btn
            >

                        <v-btn color="primary" @click="mobileStepper = 5" :disabled="isButtonDisabled">Weiter</v-btn>

                     
          </div>

                 
        </v-stepper-content>

                <v-stepper-step class="pl-0" step="5"> Abschliessen & Speichern </v-stepper-step>

               
        <v-stepper-content class="pl-0 ml-1" step="5">
                   
          <p class="caption">Du hast die Übung fertig konfiguriert. Bist du bereit, die Änderungen zu übernehmen?</p>

                   
          <v-btn color="primary" large @click="onButtonClick" :disabled="isButtonDisabled">
                        <v-icon left>mdi-check</v-icon>

                        Änderungen übernehmen          
          </v-btn>

                    <v-btn text @click="mobileStepper = 4" class="mt-2">Zurück</v-btn>

                 
        </v-stepper-content>

             
      </v-stepper>

         
    </div>

     
  </div>
</template>

<script>
import { intensityTechniqueMapping } from "./v2/utils/intensityTechniques"

export default {
  name: "WorkoutSplitEditExerciseSingle",

  props: {
    exerciseProp: { type: Object },
  },

  data() {
    return {
      intensityTechniqueMapping: intensityTechniqueMapping,
      mobileStepper: 1,
      exercise: {
        method: "",
        warmup: null,
        sets: [],
        set_exercise_settings: [],
        general_exercise_settings: [],
      },
      savedGeneralExerciseSettings: false,
      editingSetIndex: null,
      selectedTechniqueMode: "normal",
      isIntensityAlertExpanded: false,
      techniqueModes: [],
      allowArbitraryWeight: false,
      isIntensityAlertExpandedMobile: false,
      techniqueDropset: { maxWeight: 0, setCount: 3, minReps: 8, maxReps: 12, reductionWeight: 5 },
      techniqueReverseDropset: { maxWeight: 0, setCount: 3, minReps: 8, maxReps: 12, expandWeight: 20 },
      techniqueSchockwelle: { startWeight: 0, incrementWeight: 5, pause: 30, setCount: 5, reps: 4 },
      techniqueFst7: { weight: 0, pause: 30, setCount: 7, reps: 7 },
    }
  },
  computed: {
    orderedSetSettings() {
      if (!this.exercise || !this.exercise.set_exercise_settings) return []
      const order = ["Gewicht", "Dauer", "Min Wiederholungen", "Max Wiederholungen", "Pause", "Notiz"]
      const settings = [...this.exercise.set_exercise_settings]

      return settings.sort((a, b) => {
        const aIndex = order.indexOf(a.text)
        const bIndex = order.indexOf(b.text)
        if (aIndex === -1) return 1
        if (bIndex === -1) return -1
        return aIndex - bIndex
      })
    },
    hasUnconfirmedDeviceSettings() {
      if (this.savedGeneralExerciseSettings) {
        return false
      } // Gibt true zurück, wenn mindestens eine Einstellung einen Wert hat.

      return this.exercise.general_exercise_settings.some((setting) => setting.value)
    },

    isSensoProExercise() {
      return this.exercise && this.exercise.title === "Senso Pro"
    },

    isWeightlessExercise() {
      if (!this.exercise || !this.exercise.set_exercise_settings) {
        return false
      }

      return !this.exercise.set_exercise_settings.some((setting) => setting.text === "Gewicht")
    },

    hasWarmup: {
      get() {
        return !!this.exercise.warmup
      },

      set(value) {
        if (value && !this.exercise.warmup) {
          // Wenn aktiviert, ein Standard-Warmup-Objekt erstellen

          this.$set(this.exercise, "warmup", [
            { text: "Gewicht", value: "", input: "number" },

            { text: "Min Wiederholungen", value: "", input: "number" },

            { text: "Max Wiederholungen", value: "", input: "number" },
          ])
        } else if (!value) {
          // Wenn deaktiviert, auf null setzen

          this.$set(this.exercise, "warmup", null)
        }
      },
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },

    mobileTechniqueModes() {
      return this.techniqueModes.filter((mode) => mode.value !== "warmup")
    },

    availableTechniqueModes() {
      const modeOrder = ["warmup", "normal", "dropset", "reversedropset", "schockwelle", "fst7"]

      let modes = modeOrder

        .map((key) => {
          const tech = this.intensityTechniqueMapping[key]

          if (!tech) return null

          return {
            text: tech.descriptionShort,

            value: key,

            icon: tech.icon,
          }
        })

        .filter(Boolean) // Wenn die Übung kein Gewicht hat, zeige nur Aufwärm- und normale Sätze.

      if (this.isWeightlessExercise) {
        const allowedModes = ["warmup", "normal"]

        return modes.filter((mode) => allowedModes.includes(mode.value))
      }

      return modes
    },

    combinedExerciseSets() {
      if (!this.exercise) return []

      let combined = this.exercise.sets ? JSON.parse(JSON.stringify(this.exercise.sets)) : []

      if (this.exercise.warmup) {
        combined.unshift(this.exercise.warmup)
      }

      return combined
    },

    activeTechniqueInfo() {
      const mode = this.exercise.method || this.selectedTechniqueMode

      if (mode && this.intensityTechniqueMapping[mode]) {
        return this.intensityTechniqueMapping[mode]
      }

      return null
    },

    isButtonDisabled() {
      if (this.isSensoProExercise) {
        // Deaktiviert, wenn KEINE einzige Geräteeinstellung einen Wert hat.

        return !this.exercise.general_exercise_settings.some((s) => s.value)
      } // Bisherige Logik für alle anderen Übungen

      return !this.exercise.sets?.length && !this.exercise.warmup
    },

    tooltipMessage() {
      if (this.isSensoProExercise) {
        return this.isButtonDisabled ? "Mindestens eine Geräteeinstellung eingeben" : "Einstellungen speichern"
      }

      const messages = []

      if (!this.exercise.sets?.length) {
        messages.push("Mindestens einen Satz hinzufügen")
      }

      return messages.join(" ")
    },
  },

  watch: {
    selectedTechniqueMode(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isIntensityAlertExpanded = false
      }

      if (!this.isMobile) {
        const index = this.techniqueModes.findIndex((mode) => mode.value === newValue)

        this.updateHighlight(index)
      }
    },
  },

  created() {
    const modeOrder = ["warmup", "normal", "dropset", "reversedropset", "schockwelle", "fst7"]
    this.techniqueModes = modeOrder
      .map((key) => {
        const tech = this.intensityTechniqueMapping[key]
        if (!tech) return null
        return { text: tech.descriptionShort, value: key, icon: tech.icon }
      })
      .filter(Boolean)

    this.exercise = JSON.parse(JSON.stringify(this.exerciseProp))
    if (!this.exercise.warmup) this.$set(this.exercise, "warmup", null)
    if (!this.exercise.sets) this.$set(this.exercise, "sets", [])
    if (!this.exercise.set_exercise_settings)
      this.$set(this.exercise, "set_exercise_settings", [
        { text: "Gewicht", input: "number" },
        { text: "Min Wiederholungen", input: "number" },
        { text: "Max Wiederholungen", input: "number" },
        { text: "Pause", input: "number" },
        { text: "Notiz", input: "text" },
      ])
    if (!this.exercise.general_exercise_settings) this.$set(this.exercise, "general_exercise_settings", [])

    if ((!this.exercise.sets || this.exercise.sets.length === 0) && !this.exercise.warmup) {
      const cachedMinReps = localStorage.getItem("cachedMinReps")
      const cachedMaxReps = localStorage.getItem("cachedMaxReps")
      const cachedPause = localStorage.getItem("cachedPause")

      this.exercise.set_exercise_settings.forEach((setting) => {
        if (setting.text === "Min Wiederholungen" && cachedMinReps) setting.value = cachedMinReps
        if (setting.text === "Max Wiederholungen" && cachedMaxReps) setting.value = cachedMaxReps
        if (setting.text === "Pause" && cachedPause) setting.value = cachedPause
      })
    }

    if (this.isMobile && (!this.exercise.general_exercise_settings || this.exercise.general_exercise_settings.length === 0)) {
      this.mobileStepper = 2
    }
  },

  mounted() {
    if (!this.isMobile) {
      this.$nextTick(() => {
        const initialIndex = this.techniqueModes.findIndex((m) => m.value === this.selectedTechniqueMode)

        this.updateHighlight(initialIndex !== -1 ? initialIndex : 1)
      })
    }
  },

  methods: {
    shortenLabel(text) {
      return text.replace("Wiederholungen", "WH")
    },
    toggleIntensityAlertExpansionMobile(val) {
      if (this.isIntensityAlertExpandedMobile === val) return (this.isIntensityAlertExpandedMobile = false)

      this.isIntensityAlertExpandedMobile = val
    },

    toggleIntensityAlertExpansion() {
      this.isIntensityAlertExpanded = !this.isIntensityAlertExpanded
    },

    getSectionHeadlineColor(colorName, isSecondary = false) {
      if (this.$vuetify.theme.themes.dark[colorName]) {
        return this.$vuetify.theme.themes.dark[colorName]
      }

      return isSecondary ? "#42A5F5" : "#66BB6A" // Fallback: Blau / Grün
    },

    getIconColorForItem(type) {
      if (type === "advantage") return "green lighten-1"

      if (type === "reason") return "blue lighten-1"

      return "grey"
    },

    formatSetForChip(set) {
      const weight = set.find((s) => s.text === "Gewicht")?.value

      const minReps = set.find((s) => s.text === "Min Wiederholungen")?.value

      const maxReps = set.find((s) => s.text === "Max Wiederholungen")?.value

      let output = ""

      if (weight) output += `${weight}kg`

      let repsPart = ""

      if (minReps && maxReps) {
        repsPart = `${minReps}-${maxReps} Wdh.`
      } else if (minReps) {
        repsPart = `${minReps} Wdh.`
      } else if (maxReps) {
        repsPart = `bis ${maxReps} Wdh.`
      }

      if (output && repsPart) output += " / "

      output += repsPart

      return output.trim()
    },

    onButtonClick() {
      if (this.isButtonDisabled) return

      if (!this.isSensoProExercise && this.exercise.general_exercise_settings.length > 0 && this.hasUnconfirmedDeviceSettings) {
        const userConfirmed = confirm(
          "Du hast die Geräteeinstellungen noch nicht mit dem Haken bestätigt. Sollen die eingegebenen Werte trotzdem gespeichert werden?\n\nKlicke auf 'Abbrechen', um zurückzugehen und den Haken zu setzen."
        )

        if (!userConfirmed) {
          return
        }
      }

      if (this.isSensoProExercise) {
        this.exercise.isConfigured = true
      } else {
        let weights = this.exercise.sets.map((set) => parseFloat(set.find((item) => item.text === "Gewicht")?.value || 0))

        let minReps = this.exercise.sets.map((set) => parseInt(set.find((item) => item.text === "Min Wiederholungen")?.value || 0))

        let maxReps = this.exercise.sets.map((set) => parseInt(set.find((item) => item.text === "Max Wiederholungen")?.value || 0))

        this.exercise.weightSum = { min: Math.min(...weights), max: Math.max(...weights) }

        this.exercise.repSum = { min: Math.min(...minReps), max: Math.max(...maxReps) }
      }

      this.$emit("savedExercise", this.exercise)
    },
    saveSet() {
      if (this.exercise.set_exercise_settings.find((setting) => setting.value)) {
        if (this.exercise.set_exercise_settings.find((setting) => setting.text === "Gewicht" && setting.value <= 0)) {
          alert("Das Gewicht muss größer als 0 sein.")
          return
        }

        const newSet = JSON.parse(JSON.stringify(this.exercise.set_exercise_settings))

        const minReps = newSet.find((s) => s.text === "Min Wiederholungen")?.value
        const maxReps = newSet.find((s) => s.text === "Max Wiederholungen")?.value
        const pause = newSet.find((s) => s.text === "Pause")?.value
        if (minReps) localStorage.setItem("cachedMinReps", minReps)
        if (maxReps) localStorage.setItem("cachedMaxReps", maxReps)
        if (pause) localStorage.setItem("cachedPause", pause)

        if (this.selectedTechniqueMode === "warmup") {
          this.$set(this.exercise, "warmup", newSet)
          this.selectedTechniqueMode = "normal"
          return
        }

        if (this.editingSetIndex !== null) {
          // *** START KORREKTUR ***
          // Prüfen, ob der Aufwärmsatz bearbeitet wird
          if (this.exercise.warmup && this.editingSetIndex === 0) {
            this.$set(this.exercise, "warmup", newSet)
          } else {
            // Bisherige Logik für normale Arbeitssätze
            const indexToUpdate = this.exercise.warmup ? this.editingSetIndex - 1 : this.editingSetIndex
            this.exercise.sets.splice(indexToUpdate, 1, newSet)
          }
          // *** ENDE KORREKTUR ***

          this.cancelEditSet() // Ruft jetzt die zurückgesetzte Version auf
        } else {
          this.exercise.sets.push(newSet)
        }
      } else {
        alert("Füge mindestens eine Satzeinstellung hinzu")
      }
    },
    removeSetByIndex(index) {
      // *** START KORREKTUR ***
      // Die Bedingung wird erweitert: Der Aufwärmsatz wird gelöscht, wenn der Index -1 ist (mobile Ansicht)
      // ODER wenn der Index 0 ist UND ein Aufwärmsatz existiert (Desktop-Ansicht).
      if (index === -1 || (this.exercise.warmup && index === 0)) {
        this.removeWarmupSet()
        this.cancelEditSet() // Form zurücksetzen
        return
      }

      // Korrekte Index-Berechnung für das `sets`-Array
      const actualIndex = this.exercise.warmup ? index - 1 : index
      this.exercise.sets.splice(actualIndex, 1)
      // *** ENDE KORREKTUR ***

      this.cancelEditSet() // Form zurücksetzen

      // Optional: Form mit den Werten des letzten Satzes füllen
      if (this.exercise.sets.length > 0) {
        this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[this.exercise.sets.length - 1]))
      }
    },

    removeWarmupSet() {
      this.exercise.warmup = null
    },

    editSet(index) {
      if (this.exercise.warmup && index === 0) {
        this.editingSetIndex = 0

        this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.warmup))

        return
      }

      const actualIndex = this.exercise.warmup ? index - 1 : index

      this.editingSetIndex = index

      this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[actualIndex]))
    },

    cancelEditSet() {
      this.editingSetIndex = null
      if (this.exercise.sets.length > 0) {
        // Fülle die Form mit den Werten des letzten Satzes
        this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[this.exercise.sets.length - 1]))
      } else {
        // Wenn keine Sätze mehr da sind, Formularfelder leeren
        this.exercise.set_exercise_settings.forEach((setting) => {
          setting.value = ""
        })
      }
    },

    openCancelConfirm() {
      if (this.hasUnconfirmedDeviceSettings) {
        if (confirm("Du hast Geräteeinstellungen eingegeben, aber nicht mit dem Haken bestätigt. Trotzdem abbrechen?")) {
          this.$emit("cancel-edit")
        }

        return // Wichtig, damit die restliche Funktion nicht ausgeführt wird.
      }

      if (this.exercise.sets.length > 0) {
        if (confirm("Ungespeicherte Änderungen gehen verloren. Wirklich abbrechen?")) {
          this.$emit("cancel-edit")
        }
      } else {
        this.$emit("cancel-edit")
      }
    },

    saveGeneralExerciseSettings() {
      if (!this.exercise.general_exercise_settings.find((setting) => setting.value)) {
        if (confirm("Ohne Geräteeinstellungen fortfahren?")) {
          this.savedGeneralExerciseSettings = true
        }
      } else {
        this.savedGeneralExerciseSettings = true
      }
    },

    updatingSetting(event, item) {
      item.value = event.target.innerText.trim()
    },

    getImageForExercise(exercise) {
      if (exercise.picture) return this.getImageUrl(exercise.picture)

      if (exercise.manual && exercise.manual[0]?.picture) return this.getImageUrl(exercise.manual[0].picture)

      return "/img/einmalig/imageUploadPlaceholder.jpg"
    },

    getImageUrl(image) {
      if (!image) return ""

      return `/img/uebungen/${image.replace(/\.[^/.]+$/, "")}.webp`
    },

    shorten(text, length = 25) {
      if (text === "Min Wiederholungen") return "Min WH"

      if (text === "Max Wiederholungen") return "Max WH"

      if (text === "Umdrehungen pro Minute") return "UPM"

      if (text.length > length) text = text.substr(0, length) + "..."

      return text
    },

    getSettingText(setting) {
      let text = setting.value

      if (setting.text === "Gewicht") text = text + " KG"

      return text
    },

    getSettingValue(set, settingText) {
      const setting = set.find((s) => s.text === settingText)

      return setting ? parseFloat(setting.value) || setting.value : null
    },

    validateWeight(value) {
      if (this.allowArbitraryWeight) return true

      return value % 5 === 0 || "Das Gewicht muss ein Vielfaches von 5 sein."
    },

    generateSetsForTechnique() {
      this.exercise.sets = []

      if (this.selectedTechniqueMode === "dropset") {
        if (!this.techniqueDropset.maxWeight) return alert("Bitte Maximalgewicht angeben.")

        if (this.techniqueDropset.maxWeight <= 0) return alert("Bitte ein positives Maximalgewicht angeben.")

        if (this.techniqueDropset.setCount <= 0) return alert("Bitte eine positive Anzahl an Sätzen angeben.")

        if (this.techniqueDropset.setCount * this.techniqueDropset.reductionWeight >= this.techniqueDropset.maxWeight) {
          return alert("Die Reduktion pro Satz muss kleiner sein als das Maximalgewicht.")
        }

        let currentWeight = parseFloat(this.techniqueDropset.maxWeight)

        for (let i = 0; i < this.techniqueDropset.setCount; i++) {
          const newSet = [
            { text: "Gewicht", value: currentWeight, input: "number" },

            { text: "Min Wiederholungen", value: this.techniqueDropset.minReps, input: "number" },

            { text: "Max Wiederholungen", value: this.techniqueDropset.maxReps, input: "number" },

            { text: "Pause", value: 0, input: "number" },
          ]

          this.exercise.sets.push(newSet)

          currentWeight -= this.techniqueDropset.reductionWeight

          if (!this.allowArbitraryWeight) currentWeight = Math.round(currentWeight / 2.5) * 2.5
        }
      } else if (this.selectedTechniqueMode === "reversedropset") {
        if (!this.techniqueReverseDropset.maxWeight) return alert("Bitte Maximalgewicht angeben.")

        if (this.techniqueReverseDropset.maxWeight <= 0) return alert("Bitte ein positives Maximalgewicht angeben.")

        if (this.techniqueReverseDropset.setCount <= 0) return alert("Bitte eine positive Anzahl an Sätzen angeben.")

        if (this.techniqueReverseDropset.setCount * this.techniqueReverseDropset.expandWeight >= this.techniqueReverseDropset.maxWeight) {
          return alert("Die Gewichtserhöhung pro Satz muss kleiner sein als das Maximalgewicht.")
        }

        let startWeight =
          this.techniqueReverseDropset.maxWeight - (this.techniqueReverseDropset.setCount - 1) * this.techniqueReverseDropset.expandWeight

        let currentWeight = startWeight

        for (let i = 0; i < this.techniqueReverseDropset.setCount; i++) {
          const newSet = [
            { text: "Gewicht", value: Math.round(currentWeight / 2.5) * 2.5, input: "number" },

            { text: "Min Wiederholungen", value: this.techniqueReverseDropset.minReps, input: "number" },

            { text: "Max Wiederholungen", value: this.techniqueReverseDropset.maxReps, input: "number" },

            { text: "Pause", value: 0, input: "number" },
          ]

          this.exercise.sets.push(newSet)

          currentWeight = currentWeight + this.techniqueReverseDropset.expandWeight
        }
      } else if (this.selectedTechniqueMode === "schockwelle") {
        if (!this.techniqueSchockwelle.startWeight) return alert("Bitte Startgewicht angeben.")

        if (this.techniqueSchockwelle.startWeight <= 0) return alert("Bitte ein positives Startgewicht angeben.")

        if (this.techniqueSchockwelle.setCount <= 0) return alert("Bitte eine positive Anzahl an Sätzen angeben.")

        if (this.techniqueSchockwelle.incrementWeight <= 0) return alert("Bitte eine positive Gewichtserhöhung angeben.")

        let currentWeight = parseFloat(this.techniqueSchockwelle.startWeight)

        for (let i = 0; i < this.techniqueSchockwelle.setCount; i++) {
          const newSet = [
            { text: "Gewicht", value: Math.round(currentWeight / 2.5) * 2.5, input: "number" },

            { text: "Max Wiederholungen", value: this.techniqueSchockwelle.reps, input: "number" },

            { text: "Pause", value: this.techniqueSchockwelle.pause, input: "number" },
          ]

          this.exercise.sets.push(newSet)

          currentWeight = currentWeight + this.techniqueSchockwelle.incrementWeight
        }
      } else if (this.selectedTechniqueMode === "fst7") {
        if (!this.techniqueFst7.weight) return alert("Bitte Gewicht angeben.")

        if (this.techniqueFst7.weight <= 0) return alert("Bitte ein positives Gewicht angeben.")

        for (let i = 0; i < this.techniqueFst7.setCount; i++) {
          const newSet = [
            { text: "Gewicht", value: parseFloat(this.techniqueFst7.weight), input: "number" },

            { text: "Max Wiederholungen", value: this.techniqueFst7.reps, input: "number" },

            { text: "Pause", value: this.techniqueFst7.pause, input: "number" },
          ]

          this.exercise.sets.push(newSet)
        }
      }

      this.$set(this.exercise, "method", this.selectedTechniqueMode)
    },

    updateHighlight(index) {
      if (this.isMobile || index < 0) return

      this.$nextTick(() => {
        const btns = this.$el.querySelectorAll(".technique-custom-card")

        const highlight = this.$refs.highlight

        if (!btns.length || !highlight) return

        const selectedBtn = btns[index]

        if (!selectedBtn) return

        highlight.style.width = Number(selectedBtn.offsetWidth) + 4 + "px"

        highlight.style.height = Number(selectedBtn.offsetHeight) + 4 + "px"

        highlight.style.left = selectedBtn.parentElement.offsetLeft + "px"

        highlight.style.top = selectedBtn.parentElement.offsetTop + "px"
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.line-height-tight {
  line-height: 1.2;
}
.v-stepper {
  background-color: transparent !important;
}
.v-stepper__content {
  padding: 16px 0px 16px 24px;
}
::v-deep .v-stepper__step__step {
  margin-right: 12px;
}

/* Stile für Tablet/Desktop (aus vorherigen Versionen) */
.compact-input {
  width: auto;
  min-width: 50px;
  border: none;
  background: transparent;
  padding: 5px;
  font-size: 14px;
  transition: width 0.3s, border-color 0.3s;
  caret-color: white;
}
.compact-input:empty:before {
  content: "+";
  color: white;
}
.compact-input:focus {
  border-color: white; /* visuelles Feedback beim Fokus */
}
.technique-custom-card {
  position: relative;
  background: black;
  overflow: hidden;
  transition: all 0.3s ease;
  border-radius: 8px;
  color: #d7d7d7;
}

.input-card {
  border-radius: 12px;
  transition: box-shadow 0.2s ease-out;
  width: 100px;
}

/* KORRIGIERT: :focus-within als eigene Regel, nicht verschachtelt */
.input-card:focus-within {
  box-shadow: 0 0 10px rgba(var(--v-primary-base-rgb), 0.5);
}

.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: var(--v-primary); /* Fallback color */
  border-radius: 8px;
  transition: all 0.3s ease;
}

.builder-background {
  width: 100%;
  height: 100%;
  color: #fff;
  overflow-y: auto;
  position: relative;
  background: #1a1a1a;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.gradient-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: radial-gradient(circle at 15% 25%, rgba(108, 99, 255, 0.15), transparent 45%),
    radial-gradient(circle at 85% 75%, rgba(var(--v-primary-base-rgb), 0.2), transparent 45%);
  animation: rotate-gradient 25s linear infinite;
  z-index: 1;
}
@keyframes rotate-gradient {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.content-wrapper {
  position: relative;
  z-index: 2;
  padding: 24px;
}
.glass-card {
  background: rgba(44, 44, 46, 0.6);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.technique-group {
  display: flex;
  gap: 12px;
  background: rgba(0, 0, 0, 0.2);
  padding: 8px;
  border-radius: 12px;
}
.technique-item {
  flex: 1;
  flex-direction: column;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  .icon {
    color: #9e9e9e;
    transition: all 0.3s ease;
    margin-right: 8px;
  }
  .label {
    font-size: 0.9rem;
    color: #9e9e9e;
    font-weight: 500;
    transition: all 0.3s ease;
  }
}
.technique-item:hover {
  background: rgba(255, 255, 255, 0.05);
  .icon,
  .label {
    color: white;
  }
}
.technique-item.active {
  background: rgba(var(--v-primary-base-rgb), 0.2);
  border-color: var(--v-primary-base);
  box-shadow: 0 0 20px rgba(var(--v-primary-base-rgb), 0.4);
  .icon,
  .label {
    color: white;
  }
}
.sets-display-desktop {
  display: grid;
  grid-template-columns: 30% 68%;
  gap: 24px;
}
.sets-list-wrapper {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 12px;
}
.set-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: all 0.2s ease;
}
.set-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: var(--v-primary-base);
}
.set-icon {
  margin-right: 16px;
}
.set-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.edit-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
}
.set-item:hover .edit-icon {
  opacity: 0.7;
}

::v-deep .input-form-wrapper .v-text-field--solo-inverted.v-input--is-focused .v-input__slot {
  background: rgba(var(--v-primary-base-rgb), 0.2) !important;
}

.main-save-btn {
  box-shadow: 0 0 20px rgba(var(--v-primary-base-rgb), 0.5);
  transition: all 0.3s ease;
}
.main-save-btn:hover:not(:disabled) {
  box-shadow: 0 4px 30px rgba(var(--v-primary-base-rgb), 0.7);
  transform: translateY(-2px);
}
</style>
